import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c2fee02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-container" }
const _hoisted_2 = { class: "content-block" }

import InfoCard from "@/components/ui/containers/info-card.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'error-layout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(InfoCard, null, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })
      ])
    ])
  ]))
}
}

})